import {
  getDashboard,
  getRenterPlansDashboard,
  getConvertedRentersDashboard,
} from "@/common/services/dash.api";
import {
  DataProcessorService,
  DashboardApiResponse,
  RentersPlansApiResponse,
  ConvertedRentersApiResponse,
} from "./DataProcessorService";

export class DashboardService {
  /**
   * Busca todos os dados do dashboard com período opcional
   */
  static async fetchDashboardData(filters?: { startDate?: string; endDate?: string }): Promise<ReturnType<typeof DataProcessorService.processFullDashboardData>> {
    try {
      const [leadDashboard, rentersPlans, convertedRenters] = await Promise.all([
        getDashboard(filters || {}),
        getRenterPlansDashboard(),
        getConvertedRentersDashboard(filters || {}),
      ]);

      return DataProcessorService.processFullDashboardData(
        leadDashboard as DashboardApiResponse,
        rentersPlans as RentersPlansApiResponse,
        convertedRenters as ConvertedRentersApiResponse
      );
    } catch (error) {
      console.error("Erro ao buscar dados do dashboard:", error);
      throw error;
    }
  }

  /**
   * Busca dados filtrados do dashboard (incluindo novos planos)
   */
  static async fetchFilteredData(
    filters: { startDate?: string; endDate?: string }
  ): Promise<ReturnType<typeof DataProcessorService.processFullDashboardData>> {
    try {
      const [leadDashboard, rentersPlans, convertedRenters] = await Promise.all([
        getDashboard(filters),
        getRenterPlansDashboard(),
        getConvertedRentersDashboard(filters),
      ]);

      // Usar processFullDashboardData para incluir planos atualizados
      return DataProcessorService.processFullDashboardData(
        leadDashboard as DashboardApiResponse,
        rentersPlans as RentersPlansApiResponse,
        convertedRenters as ConvertedRentersApiResponse
      );
    } catch (error) {
      console.error("Erro ao buscar dados filtrados:", error);
      throw error;
    }
  }
}
